import React from "react";
import CustomBreadCrumb from "../../../components/breadcrumb";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../../constants/routes";
import GeneralDetailTaskContent from "./components/GeneralDetailTaskContent";
import { useLocation } from "react-router-dom";
import withAuth from "../../../HOC/withAuth";
import { Flex } from "@fluentui/react-northstar";

const GeneralDetailTask = () => {
    const { t } = useTranslation();

    const location = useLocation();

    const accessStorage = localStorage.getItem("detail");
    const storageObj = JSON.parse(accessStorage);

    const is_in_preonboarding = storageObj.state.detail.is_in_preonboarding;

    const NAV_LIST = [
        {
            label: t("pages.manage_modal_tasks.breadcrumb.nav_manage_task"),
            href: ROUTES.task_manager,
        },
        {
            label: t("pages.manage_modal_tasks.breadcrumb.nav_detail_task"),
            href: "#",
        },
    ];

    if (location.state?.breadcrumb?.includes("onboarding")) {
        NAV_LIST.unshift({
            label: "Onboarding",
            href: ROUTES.onboarding.home,
        });
    }
    if (location.state?.breadcrumb?.includes("offboarding")) {
        NAV_LIST.unshift({
            label: "Offboarding",
            href: ROUTES.offboarding.home,
        });
    }

    return (
        <Flex column fill>
            {!is_in_preonboarding && <CustomBreadCrumb navList={NAV_LIST} />}

            <Flex fill>
                <GeneralDetailTaskContent
                    is_in_preonboarding={is_in_preonboarding}
                />
            </Flex>
        </Flex>
    );
};

export default withAuth(GeneralDetailTask);
